<h1 mat-dialog-title>{{((isEdit)? 'map.sidebar.shape.form.title_edit': 'map.sidebar.shape.form.title_new') | translate}}
</h1>
<div mat-dialog-content [formGroup]="shapeForm">

  <div class="row mb-2">
    <div class="visibility" [hidden]="!publicPermission">
      <mat-slide-toggle formControlName="accessibility">
        <span class="visibility-text">{{ 'map.sidebar.bookmark.set_public' | translate }}</span>
      </mat-slide-toggle>
      <mat-icon class="visibility-eye">{{ shapeForm.get('accessibility').value ? 'visibility' : 'visibility_off'}}</mat-icon>
    </div>

    <div class="col form-field-container mb-2">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{'map.sidebar.shape.form.label' | translate}}</mat-label>
        <input matInput [readonly]="(isEdit)? 'true' : null" formControlName="label">
        <mat-error *ngIf="shapeForm.get('label').hasError('required')">{{'common.required_field' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col form-field-container mb-2">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{'map.sidebar.shape.form.layer_style' | translate}}</mat-label>
        <mat-select formControlName="style" required>
          <mat-option *ngFor="let style of layerStyleOptions" [value]="style.name">
            <div class="d-flex align-items-center">
              <img style="width: 30px;height: 30px; margin-right: 5px;" [src]="style.image$ | async" />
              <div class="text-capitalize"> {{style.label}}</div>
            </div>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="shapeForm.get('style').hasError('required')">{{'common.required_field' | translate}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-12 form-field-container mb-2">
      <mat-form-field appearance="fill" class="w-100 mb-2" (click)="fileInput.click()">
        <mat-label>{{'map.sidebar.shape.form.choose_file' | translate}}</mat-label>
        <!-- <input matInput > -->
        <div class="d-flex justify-space-between">
          <input matInput formControlName="file_" required>
          <button mat-icon-button>
            <mat-icon>file_upload</mat-icon>
          </button>
        </div>
        <mat-error *ngIf="shapeForm.get('file').hasError('required')">{{'common.required_field' | translate}}
        </mat-error>
        <mat-error *ngIf="shapeForm.get('file').hasError('unsupportedFile')">{{'map.sidebar.shape.file_error' | translate}}
        </mat-error>
        <input #fileInput type="file" [accept]="getAvailableExtensions()" (change)="onFileSelect($event)" required hidden>
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-6 form-field-container">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{'map.sidebar.shape.form.projection' | translate}}</mat-label>
        <mat-select
          formControlName="projection"
          [matTooltip]="getSelectedTooltipInfo(shapeForm.get('projection').value)"
          required
          [disabled]="selectedFileExtension === 'kmz' || selectedFileExtension === 'kml' || selectedFileExtension === 'xml'"
          [value]="shapeForm.get('projection').getRawValue()"
        >
          <mat-option
            *ngFor="let projection of registeredProjections"
            [value]="projection.code"
            #tooltip="matTooltip"
            matTooltipPosition="right"
            [matTooltip]="getTooltipInfo(projection)"
          >
            {{ getDisplayName(projection) }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="shapeForm.get('projection').hasError('required')">{{'common.required_field' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-6 form-field-container">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{'map.sidebar.shape.form.note' | translate}}</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="notes" cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"></textarea>
        <mat-error *ngIf="shapeForm.get('notes').hasError('required')">{{'common.required_field' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{'common.close' | translate}}</button>
  <button mat-raised-button color="primary" (click)="save()">{{'common.save' | translate}}</button>
</div>
